import TrackHoverPNG from '@assets/player/track-hover.png';
// @ts-expect-error missing types
import { IconLayer } from '@deck.gl/layers';
import type { Tuple2 } from 'src/lib/player/constants';
import { TRACK_HOVER_WIDTH } from './MarkerContext';

export default function createTrackHoverLayer(highlightedLocation: null | Tuple2): IconLayer {
  return new IconLayer({
    id: 'track-hover',
    iconAtlas: TrackHoverPNG,
    iconMapping: {
      hover: {
        x: 0,
        y: 0,
        width: 2 * TRACK_HOVER_WIDTH,
        height: 2 * TRACK_HOVER_WIDTH,
        pixelRatio: '1',
        anchorX: TRACK_HOVER_WIDTH,
        anchorY: 1.8 * TRACK_HOVER_WIDTH,
      },
    },
    data: highlightedLocation != null ? [highlightedLocation] : [],
    pickable: false,
    getIcon: () => 'hover',
    getPosition: (d: Tuple2) => d,
    getSize: TRACK_HOVER_WIDTH,
  });
}
